export default function AVERAGEIF() {
  return <div>Excel_AVERAGEIF</div>;
}
